<template>
  <div>
    <div v-if="loading_graph === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <div class="pa-3">
          <div class="grid_select">
            <div class="grid_header">
              <div class="mx-auto">
                <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_view" :src="img_view"/>
              </div>
              <div class="pt-3 pl-2" style="font-size: 26px"><b>ยอดผู้เข้าชมเว็บไซต์</b></div>
            </div>
            <div class="grid_half">
              <div class="ma-2">
                <v-select color="#86bc3a" @input="dump_data_select()" :items="month" item-text="name" item-value="id" v-model="selected_month" prepend-inner-icon="mdi-calendar-month-outline" label="เดือน" hide-details="auto" outlined></v-select>
              </div>
              <div class="ma-2">
                <v-select color="#86bc3a" @input="dump_data_select()" :items="year_arr" item-text="show_year" item-value="year_eng" v-model="selected_year" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined></v-select>
              </div>
            </div>
          </div>
          <div style="height: 40vh !important">
            <canvas id="myChartView"></canvas>
          </div>
        </div>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>

</template>

<script>
import Chart from "chart.js/auto";
import img_view from "@/assets/browser.png";
import {HTTP} from "@/axios";


export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "View_total",
  data() {
    return {
      loading_graph: false,
      overlay: false,
      console_chart_view: null,
      selected_month: null,
      selected_year: null,
      myChartView: null,
      img_view: img_view,
      month: [
        {id: 1, name: 'มกราคม'},
        {id: 2, name: 'กุมภาพันธ์'},
        {id: 3, name: 'มีนาคม'},
        {id: 4, name: 'เมษายน'},
        {id: 5, name: 'พฤษภาคม'},
        {id: 6, name: 'มิถุนายน'},
        {id: 7, name: 'กรกฎาคม'},
        {id: 8, name: 'สิงหาคม'},
        {id: 9, name: 'กันยายน'},
        {id: 10, name: 'ตุลาคม'},
        {id: 11, name: 'พฤศจิกายน'},
        {id: 12, name: 'ธันวาคม'},
      ],
      year_arr: [],
      graph_list: [],
      month_list: [],
    }
  },
  methods: {
    async year_function() {
      this.year_arr = []
      let arr_year = [0, 1, 2]
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      let month_selected = count_year.getMonth() + 1
      for (let i = 0; i < arr_year.length; i++) {
        let count_th = ((full_year + 543) - i);
        let count_eng = ((full_year) - i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_month = month_selected
      this.selected_year = this.year_arr[0].year_eng
      await this.dump_data_select()
    },
    async dump_data_select() {
      this.graph_list = []
      this.month_list = []
      await HTTP.post('/dashboards/visitors', {
        year: this.selected_year,
        month: this.selected_month,
      }).then((res) => {
        if (res.data.success === true) {
          res.data.object.forEach((data) => {
            this.graph_list.push(parseFloat(data.values))
            this.month_list.push(parseInt(data.month))
          })
          if (this.myChartView !== null) {
            this.myChartView.destroy()
          }
          this.chart_view()
        }
      })
    },
    chart_view() {
      let data = {
        labels: this.month_list,
        datasets: [
          {
            label: 'ยอดผู้เข้าชม',
            data: this.graph_list,
            borderColor: '#8CC63E',
            backgroundColor: '#8CC63E',
            fill: false
          },
        ]
      }
      let config = {
        type: 'line',
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
        }
      }
      const ctx = document.getElementById('myChartView');
      this.myChartView = new Chart(ctx, config)
    },
  },
  mounted() {
    this.year_function()
  }
}
</script>

<style scoped>
.grid_header {
  display: grid;
  grid-template-columns: 10% 90%;
}
.grid_select {
  display: grid;
  grid-template-columns: 70% 30%;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
@media only screen and (max-width: 1180px) {
  .grid_header {
    display: grid;
    grid-template-columns: 30% 70%;
  }
  .grid_select {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_header {
    display: grid;
    grid-template-columns: 25% 75%;
  }
  .grid_select {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
